import styled from 'styled-components'
import theme from 'stories/utils/theme'
import MobileDummyMenu from './ExperimentElements/MobileDummyMenu'
import { Know } from 'interfaces/Know'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'

const Container = styled.div<{
    isDialog?: boolean
    backgroundColor?: string
}>`
    position: ${({ isDialog }) => (isDialog ? 'absolute' : 'fixed')};
    bottom: 0px;
    left: 0px;
    width: 100%;
    //overflow: hidden;
    background: ${theme.colors.white};
    height: 60px;
    z-index: ${theme.zIndex.FAB};
    display: grid;
    box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.2) -6px -2px 16px 0px;
`

interface Props {
    onDownloadButtonClick(platform: 'android' | 'ios'): void
    isDialog?: boolean
    mobileOS: 'ios' | 'android'
    downloadDeepLinkPath?: string
    know?: Know
}

const ConversionBottomBanner = (props: Props) => {
    const lg = useMedia(deviceSize.lg)

    const showDummyMenu = lg

    if (!showDummyMenu || !props.know) return null

    return (
        <>
            <Container isDialog={!!props.isDialog}>
                <MobileDummyMenu know={props.know} />
            </Container>
        </>
    )
}

export default ConversionBottomBanner
